import React from 'react';
import {Row, Tab, Table, Tabs} from "react-bootstrap";
import moment from "moment/moment";
import numberFormat from "../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute} from "../../routesConstants";
import _ from 'lodash'

const RateHawkKayarRender = ({data}) => {

  return (
    <>
      <p className={'h4'}>Период {moment.utc(data.start).format('DD.MM.YYYY')} - {moment.utc(data.end).format('DD.MM.YYYY')}</p>
      <Row>
        <Tabs defaultActiveKey="correct">
          <Tab
            eventKey="correct"
            title={`Правильные (${data.response.correct.length})`}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.response.correct)}
            </Table>
          </Tab>
          <Tab
            eventKey="ratehawkMissing"
            title={`Нет в RateHawk (${data.response.ratehawkMissing.length})`}
          >
            <Table striped hover>
              {renderHeader()}
              {renderStandartBody(data.response.ratehawkMissing)}
            </Table>
          </Tab>
          <Tab
            eventKey="kayarMissing"
            title={`Нет в Kayar (${data.response.kayarMissing.length})`}
          >
            <Table striped hover>
              <thead>
              <tr>
                <td>Индивидуальный код</td>
                <td>Период</td>
                <td>Подробности</td>
                <td>Стоимость</td>
              </tr>
              </thead>
              <tbody>
              {data.response.kayarMissing.map((row, index) => {
                return <tr key={index}>
                  <td>{row.idInOneC}</td>
                  <td>{row.checkIn} - {row.checkOut}</td>
                  <td>{row.description}</td>
                  <td>{numberFormat(row.total)}</td>
                </tr>
              })}
              <tr>
                <td colSpan={3}>
                  <b>Итого</b>
                </td>
                <td>
                  <b>{numberFormat(_.sumBy(data.response.kayarMissing, 'total'))}</b>
                </td>
              </tr>
              </tbody>
            </Table>
          </Tab>
          <Tab
            eventKey="diff"
            title={`Отличаются (${data.response.diff.length})`}
          >
            <Table striped hover>
              {renderHeader(true)}
              {renderStandartBody(data.response.diff, true)}
            </Table>
          </Tab>
        </Tabs>

      </Row>

    </>
  );
};

export default RateHawkKayarRender;

const renderHeader = (diff) => {
  return <thead>
  <tr>
    <td>Индивидуальный код</td>
    <td>Период</td>
    <td>Пассажир</td>
    <td>Услуга</td>
    <td>Подробности</td>
    <td>Стоимость</td>
    {diff && <td>Стоимость RateHawk</td>}

  </tr>
  </thead>
}

const renderStandartBody = (array, diff) =>{
  return <tbody>
  {array.map((u, index) => {
    return (
      <tr key={index}>
        <td>
          {u.id ? <Link to={TouristServicesEditRoute + u.id} target={'_blank'}>{u.idInOneC}</Link> : u.idInOneC}
        </td>
        <td>{u.checkIn} - {u.checkOut}</td>
        <td>{u.pax}</td>
        <td>{u.type}</td>
        <td>{[u.hotel, u.city, u.country].join(',')}</td>
        <td>{numberFormat(u.total)}</td>
        {diff && <td>{numberFormat(u.ratehawkTotal)}</td>}

      </tr>
    );
  })
  }
  <tr>
    <td colSpan={5}>
      <b>Итого</b>
    </td>
    <td>
      <b>
        {numberFormat(_.sumBy(array,'total'))}
      </b>
    </td>
    {diff && <td>
      <b>{numberFormat(_.sumBy(array, 'ratehawkTotal'))}</b>
    </td>}
  </tr>
  </tbody>

}
